import FormService from "../../services/FormService";
import FormInput from '../../components/FormInput';
import SelectPicker from '../../components/SelectPicker';

export default {
	components: {
		FormInput,
		SelectPicker,
	},
	data() {
		return {
			form: new FormService({
				name: null,
				name_uz: null,
				name_en: null,
				description: null,
				description_uz: null,
				description_en: null,
				percent: null,
				status: null,
			}),

			privileges: [],
			modelStatus: [
				{
					"code": 5,
                    "name": "Выключено",
				},
				{
					"code": 10,
                    "name": "Включено",
				},
			],
			status: 3,
		}
	},
	methods: {
		Create() {
			this.form.post('privileges.create')
				.then(res => {
					if (!res.errors) {
						$('#exampleModal').modal('hide');
						this.GetAll();
						this.$store.commit('successNotify')();
					}
				});
		},
		Read(id) {
			this.$api.get('privileges.show', id)
				.then(res => {
					this.form.setData(res.data);
					$('#exampleModal').modal('show');
				});
		},
		Update() {
			this.form.put('privileges.update', this.form.id)
				.then(res => {
					if (!res.errors) {
						$('#exampleModal').modal('hide');
						this.GetAll();
						this.$store.commit('successNotify')();
					}
				});
		},
		Delete(id) {
			if (confirm(this.i18n('You are about to delete the record! \nAre you sure?'))) {
				this.$api.delete('privileges.delete', id)
					.then(res => {
						if (!res.errors) {
							this.GetAll();
							this.$store.commit('successNotify')();
						}
					});
			}
		},
		GetAll() {
			this.$api.get('privileges.index')
				.then(res => {
					// console.log(res);
					this.privileges = res.data;
				});
		},
	},
	mounted() {
		this.GetAll();


		$('#exampleModal').on('hidden.bs.modal', (e) => {
			this.form.reset();
		})
	}
}
